<script setup>
import { Dialog, DialogPanel, DialogTitle, DialogDescription } from '@headlessui/vue'
import { SecondaryButton } from "@codinglabsau/ui"
import { XMarkIcon } from "@heroicons/vue/24/solid"

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  unmount: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'max-w-sm',
  },
})

const emits = defineEmits(['update:modelValue'])

const onClose = (value) => {
  emits('update:modelValue', value)
}
</script>

<template>
  <Dialog :unmount="unmount" :open="modelValue" @close="onClose" class="relative z-50">
    <div class="fixed bg-black/25 top-0 left-0 right-0 bottom-0 overflow-y-auto">
      <div class="flex min-h-full items-start justify-center p-4">
        <DialogPanel :class="[size]" class="w-full rounded bg-white p-4">
          <DialogTitle v-if="$slots.title" class="mb-2">
            <div class="flex items-center justify-between">
              <div>
                <h2 class="text-lg text-gray-700 font-semibold">
                  <slot name="title"></slot>
                </h2>
              </div>
              <div>
                <SecondaryButton class="!p-0 !hover:bg-transparent border-none bg-transparent" as="button" type="button" @click="emits('update:modelValue', false)">
                  <XMarkIcon class="w-6 h-6" />
                </SecondaryButton>
              </div>
            </div>
          </DialogTitle>
          <DialogDescription v-if="$slots.description" class="mb-4">
            <div class="text-sm">
              <slot name="description"></slot>
            </div>
          </DialogDescription>
          <div class="space-y-3">
            <slot></slot>
          </div>
        </DialogPanel>
      </div>
    </div>
  </Dialog>
</template>
